import MiniFormDialog from '../../../../components/modal/miniFormDialog';
import {useTranslation} from 'react-i18next';
import PlansForm from './plansForm';
import {useState} from 'react';
import moment from 'moment';
import {setSnackbar} from '../../../../store/reducers/globals';
import {useDispatch} from 'react-redux';
import Notes from '../../../../util/notes';

const MedicalPlan = (props) => {
    const {t} = useTranslation();
    const dispatch = useDispatch();

    // const [values, setValues] = useState(props.patient?.studies?.medicalPlan);
    const [values, setValues] = useState({...props.patient?.studies?.medicalPlan, who: null, when: moment()});
    const [formIsModified, setFormIsModified] = useState(false);

    const sendChange = () => {
        if (moment(values.when).isValid()) {
            props.onChange([{
                name: `studies.medicalPlan`,
                value: values,
                noteToAdd: Notes.getPlansNote(props._formTitle, values, props.patient?.studies?.medicalPlan),
            }]);
            props.onClose();
        } else {
            dispatch(setSnackbar({type: 'error', message: t('Date input is not correct.')}));
        }
    };

    return (
        <MiniFormDialog
            title={t(props._formTitle)}
            open={props.open}
            onClose={props.onClose}
            disableSubmit={!formIsModified}
            onSave={sendChange}
            formOptions={props._formOptions}
        >
            <PlansForm
                label="Clinician"
                type="studies.medicalPlan"
                withText
                withNotes
                allowedConsultants="medicalPlan"
                onChangingValues={setValues}
                value={values}
                setFormIsModified={setFormIsModified}
                {...props}
            />
        </MiniFormDialog>
    );
};

export default MedicalPlan;